const Filters = ({ modalidades, facultades, modalidadFilter, setModalidadFilter, tituloFilter, setTituloFilter, facultadFilter, setFacultadFilter }) => {
  const selectClass = "block w-full pl-3 pr-10 py-2 text-base border-slate-300 focus:outline-none focus:ring-primary-500 focus:border-primary-500 sm:text-sm rounded-md shadow-sm bg-white text-slate-700";

  return (
    <div className="grid gap-4 md:grid-cols-3 bg-slate-50 p-4 rounded-xl border border-slate-100">
      <div className="space-y-1">
        <label className="block text-xs font-medium text-slate-500 uppercase tracking-wider">Modalidad</label>
        <select value={modalidadFilter} onChange={(e) => setModalidadFilter(e.target.value)} className={selectClass}>
          <option value="">Todas las Modalidades</option>
          {modalidades.map(mod => <option key={mod} value={mod}>{mod}</option>)}
        </select>
      </div>

      <div className="space-y-1">
        <label className="block text-xs font-medium text-slate-500 uppercase tracking-wider">Título</label>
        <select value={tituloFilter} onChange={(e) => setTituloFilter(e.target.value)} className={selectClass}>
          <option value="">Todos los Títulos</option>
          <option value="Licenciatura">Licenciatura</option>
          <option value="Tecnicatura">Tecnicatura</option>
          <option value="Ingeniería">Ingeniería</option>
          <option value="Profesorado">Profesorado</option>
          <option value="Contador Público">Contador Público</option>
          <option value="Abogado">Abogado</option>
        </select>
      </div>

      <div className="space-y-1">
        <label className="block text-xs font-medium text-slate-500 uppercase tracking-wider">Facultad</label>
        <select value={facultadFilter} onChange={(e) => setFacultadFilter(e.target.value)} className={selectClass}>
          <option value="">Todas las Facultades</option>
          {facultades.map(fac => <option key={fac} value={fac}>{fac}</option>)}
        </select>
      </div>
    </div>
  );
};
export default Filters;